import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';

import CloseIcon from '../../../../assets/images/close-icon.svg';
import DirectoryTeamsFilter from './DirectoryTeamsFilter';
import Button from '../../../../components/Buttons/DialogButton';
import dataModel from '../../../../models/DataModel';
import './DirectoryTeamsFilterPopout.scss';

// Change DialogButton to the appropriate name
class DirectoryTeamsFilterPopout extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      changedData: false,
      selectedMarket:
        props.selectedFilters && props.selectedFilters.market
          ? props.selectedFilters.market
          : null,
      selectedTeamLead:
        props.selectedFilters && props.selectedFilters.lead
          ? props.selectedFilters.lead
          : null,
      selectedFilters: props.selectedFilters ? props.selectedFilters : {},
    };
  }

  handleMarketSelection(market) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.market = market;
    this.setState({
      selectedMarket: market,
      selectedFilters: copySelectedFilters,
      changedData: true,
    }, () => console.log(''));
  }

  handleLeadSelection(lead) {
    let copySelectedFilters = Object.assign({}, this.state.selectedFilters);
    copySelectedFilters.lead = lead;
    this.setState({
      selectedTeamLead: lead,
      selectedFilters: copySelectedFilters,
      changedData: true,
    }, () => console.log(''));
  }

  handleApplyFilter() {
    this.props.handleCancel();
    let filter = {};
    if (this.state.selectedMarket) {
      filter.market = this.state.selectedMarket;
    }

    if (this.state.selectedTeamLead) {
      filter.lead = this.state.selectedTeamLead;
    }

    if (this.props.handleApplyFilter) {
      this.props.handleApplyFilter(filter);
    }
  }

  handleCancel() {
    this.props.handleCancel();
    this.setState({
      changedData: false,
      selectedFilters: null,
      selectedMarket: null,
      selectedTeamLead: null,
    });
  }

  handleClear() {
    this.props.handleClear();
    this.setState({
      changedData: false,
      selectedFilters: null,
      selectedMarket: null,
      selectedTeamLead: null,
    });
  }

  render() {
    const { right, top } = this.props;

    let style = {
      right: right,
      top: top,
    };

    return (
      <div className="directory-users-filter-popout-container" style={style}>
        <div className="arrow-up" />
        <div className="directory-users-filter-popout-header">
          <div className="directory-users-filter-popout-title">{'FILTER TEAMS'}</div>
          <img
            className="directory-users-filter-popout-close-icon"
            src={CloseIcon}
            alt="close"
            onClick={this.handleCancel}
          />
        </div>
        <div className="directory-users-filter-popout-filter-container">
          <DirectoryTeamsFilter
            handleMarketSelection={this.handleMarketSelection}
            handleLeadSelection={this.handleLeadSelection}
            selectedFilters={this.state.selectedFilters}
            markets={this.props.markets}
            companies={this.props.companies}
          />
        </div>

        <div className="directory-users-button-container">
          <Button
            width={40}
            height={32}
            text={this.textMap.clear.toUpperCase()}
            fontStyle={{
              color: '#9b9b9b',
              fontFamily: 'Open Sans',
              fontSize: '12px',
              letterSpacing: '0px',
              lineHeight: '32px',
            }}
            fill="#ffffff"
            handleClick={this.handleClear}
          />
          {this.state.changedData ?
            <Button
              width={60}
              height={32}
              text={this.textMap.apply.toUpperCase()}
              fontStyle={{
                color: '#ffffff',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                letterSpacing: '0px',
                lineHeight: '32px',
              }}
              fill="#5db348"
              handleClick={this.handleApplyFilter}
            /> :
            <Button
              width={60}
              height={32}
              text={this.textMap.apply.toUpperCase()}
              disabled={true}
              border={'solid 1px #5db348'}
              fontStyle={{
                color: '#5db348',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                letterSpacing: '0px',
                lineHeight: '32px',
              }}
              fill="#ffffff"
            />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = dispatch => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(DirectoryTeamsFilterPopout);



// WEBPACK FOOTER //
// ./src/containers/Directory/DirectoryTeamsSearchFilter/DirectoryTeamsFilterPopout/index.js